import USER from './images/user.png';

export default {
    USER
};
